import type { PropsWithChildren } from 'react'

import { StyledContainer } from './Container.Styled'

type Props = PropsWithChildren<{
  className?: string
}>

export const Container = ({ className, children }: Props) => {
  return <StyledContainer className={className}>{children}</StyledContainer>
}

export default Container
